import styled from 'styled-components';

export default styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	width: 35rem;
	position: relative;
	margin-bottom: 5rem;

	.group-input-textbox {
		width: 30rem;
		.motif-input {
			height: 4.4rem;
			padding: 2rem 0.5rem 0.8rem 1rem;
		}
		.motif-label-for-text {
			top: 1.5rem;
		}
		.motif-input-clear-button {
			top: 1.5rem;
			&:hover,
			&:focus {
				box-shadow: none !important;
			}
		}
		svg {
			&.small {
				width: 2rem;
				height: 2rem;
				max-width: 2rem;
				max-height: 2rem;
			}
		}

		.with-error,
		.fixed-error{
			margin-bottom: 0;
		}

	}
	.clearall {
		margin: 0 1.5rem;
		height: 4.4rem;
		display: flex;
		align-items: center;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
`;
